import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { AggregateReports, CustomReports, FlaggedReports } from "..";
import { TabContent, TabItem } from "../../components";
import { TabRouteParams } from "../../types/sharedTypes";

export const Reports: React.FC = (): JSX.Element => {
  const defaultActiveTab = "reports/flagged";
  const { activeTab } = useParams<TabRouteParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeTab) {
      navigate(`/${defaultActiveTab}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      if (tab === "reports") {
        navigate(`/${tab}`);
      } else {
        navigate(`/reports/${tab}`);
      }
    }
  };

  return (
    <main className="relative pb-20 px-4 z-0 overflow-y-auto w-full">
      <div className="mt-8">
        <div className="max-w-8xl mx-auto w-full flex justify-between items-center pb-2">
          <div className="w-full flex flex-col justify-start px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mt-4 mb-8" data-testid="reports-header">
              <h2 className="text-3xl leading-6 font-bold text-gray-900">
                Reports
              </h2>
            </div>

            <div
              className="w-full border-b border-gray-200"
              data-testid="reports-tabs-container"
            >
              <ul
                className="-mb-px flex space-x-8"
                data-testid="reports-page-tabs"
              >
                <TabItem
                  page="flagged"
                  title="Flagged"
                  activeTab={activeTab ? activeTab : defaultActiveTab}
                  toggleTab={toggleTab}
                />
                <TabItem
                  page="aggregate"
                  title="Aggregate"
                  activeTab={activeTab ? activeTab : defaultActiveTab}
                  toggleTab={toggleTab}
                />
                <TabItem
                  page="custom"
                  title="Custom"
                  activeTab={activeTab ? activeTab : defaultActiveTab}
                  toggleTab={toggleTab}
                />
              </ul>
            </div>
          </div>
        </div>

        <div className="h-screen" data-testid="reports-page-contents">
          <TabContent
            page="flagged"
            activeTab={activeTab ? activeTab : defaultActiveTab}
          >
            <FlaggedReports />
          </TabContent>
          <TabContent
            page="aggregate"
            activeTab={activeTab ? activeTab : defaultActiveTab}
          >
            <AggregateReports />
          </TabContent>
          <TabContent
            page="custom"
            activeTab={activeTab ? activeTab : defaultActiveTab}
          >
            <CustomReports />
          </TabContent>
        </div>
      </div>
    </main>
  );
};
